import React from 'react';
import PropTypes from 'prop-types';
import xhr from '../../xhr.js';
import SearchResults from './search-results';

class SearchResultsContainer extends React.PureComponent {
  static propTypes = {
    getItemProps: PropTypes.func,
    highlightedIndex: PropTypes.number,
    maxResults: PropTypes.number,
    searchCategory: PropTypes.string,
    searchPhrase: PropTypes.string,
  };

  state = {
    results: [],
    isLoading: true,
  }

  componentDidMount() {
    this.query();
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.searchCategory !== this.props.searchCategory ||
      prevProps.searchPhrase !== this.props.searchPhrase
    ) {
      this.abortQuery()
      this.query();
    }
  }

  componentWillUnmount() {
    this.abortQuery();
  }

  query() {
    const { searchCategory, searchPhrase } = this.props;

    this.setState({ isLoading: true });
    this.xhr = xhr(`/finder/search.json?term=${searchPhrase}&category=${searchCategory}`, {
      onSuccess: this.onSuccess,
    });
  }

  abortQuery() {
    if (this.xhr) {
      this.xhr.abort();
    }
  }

  onSuccess = (results) => {
    this.setState({
      results,
      isLoading: false,
    });

    this.xhr = undefined;
  }

  render() {
    const {
      getItemProps,
      highlightedIndex,
      maxResults,
      searchPhrase,
    } = this.props;
    const { isLoading, results } = this.state;

    if (isLoading) return null;

    const groups = results.filter((item) => item.type === 'group');
    const savedSearches = results.filter((item) => item.type === 'search');
    const sources = results.filter((item) => item.type === 'source');

    return (
      <SearchResults
        groups={groups}
        savedSearches={savedSearches}
        sources={sources}
        getItemProps={getItemProps}
        highlightedIndex={highlightedIndex}
        maxResults={maxResults}
        searchPhrase={searchPhrase}
      />
    );
  }
}

export default SearchResultsContainer;
